<template>
  <div class="section-body px-16 py-24">
    <p class="caption-bold mb-16">
      {{ title }}
    </p>
    <slot />
  </div>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    required: true
  }
})
</script>

<style lang="scss" scoped>
.section-body {
  text-align: left;
  border-bottom: 1px solid $gray-2;
}
</style>
